import { render, staticRenderFns } from "./payInfo.vue?vue&type=template&id=a5b35fdc&scoped=true"
import script from "./payInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./payInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./payInfo.vue?vue&type=style&index=0&id=a5b35fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b35fdc",
  null
  
)

export default component.exports